import classNames from 'classnames';
import React, {FC} from 'react';
import styles from './BottomButtons.module.scss';

export interface BottomButtonsProps {
    isApplyDisabled: boolean;
    isClearHidden?: boolean;
    applyCallback: () => void;
    clearCallback: () => void;
    applyOnly?: boolean;
}

const BottomButtons: FC<BottomButtonsProps> = ({
    isApplyDisabled,
    isClearHidden,
    applyCallback,
    clearCallback,
    applyOnly,
}) => {
    const clearClasses = classNames([styles.button, styles.clear], {
        [styles.hidden]: isClearHidden,
    });

    const applyClasses = classNames([styles.button], {
        [styles.disabled]: isApplyDisabled,
        [styles.fullWidth]: applyOnly,
    });

    return (
        <div className={styles.container}>
            {!applyOnly && (
                <button type='button' className={clearClasses} onClick={clearCallback}>
                    Clear all
                </button>
            )}
            <button type='button' className={applyClasses} onClick={applyCallback}>
                Apply
            </button>
        </div>
    );
};

export default BottomButtons;
